import {
  Directive,
  ViewContainerRef,
  ComponentFactoryResolver,
  ElementRef,
  forwardRef,
  ChangeDetectorRef,
  OnInit,
  OnChanges,
  SimpleChanges,
  Input,
  DoCheck,
  KeyValueDiffer,
  KeyValueDiffers,
  Output,
  EventEmitter,
  Renderer2,
  NgZone,
  OnDestroy
} from '@angular/core';
import { DaterangepickerComponent } from './daterangepicker.component';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl } from '@angular/forms';
//import _moment from 'proxies/dayjs';
import { LocaleConfig } from './daterangepicker.config';
import { LocaleService } from './locale.service';
//
import _moment from 'proxies/dayjs';
import { UtilService } from '../../services/util.service';
import { ValidationService } from '../form/validation.service';
import { Subscription } from 'rxjs';
const moment = _moment;

@Directive({
    selector: 'input[ngxDaterangepickerMd]',
    host: {
        '(keyup.esc)': 'hide()',
        '(blur)': 'onBlur()',
        '(click)': 'open()',
        '(keyup)': 'inputChanged($event)'
    },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DaterangepickerDirective), multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => DaterangepickerDirective), multi: true
        }
    ],
    standalone: false
})
export class DaterangepickerDirective implements OnInit, OnChanges, DoCheck, OnDestroy {
  private sub: Subscription = new Subscription();
  private boundOutsideClick: (event: any) => void;
  public picker: DaterangepickerComponent;
  private _onChange = Function.prototype;
  private _onTouched = Function.prototype;
  private _validatorChange = Function.prototype;
  private _value: any;
  private localeDiffer: KeyValueDiffer<string, any>;
  //added for validation
  @Input('validations') _validations: any;
  @Input()
  set disableControl(condition: boolean) {
    this._el.nativeElement.disabled = condition;
  }

  @Input()
  minDateNumber: number;
  @Input()
  minDateUnit: any;
  @Input() disbledTimePickerRange:any ={};
  @Input()
  maxDateNumber: number;
  @Input()
  maxDateUnit: any;
  @Input()
  maxSpan: number;
  @Input()
  minDate: any
  @Input()
  maxDate: any
  @Input()
  autoApply: boolean = true;
  @Input()
  forceEndOfDay: Boolean = false;
  @Input()
  alwaysShowCalendars: boolean;
  @Input()
  showCustomRangeLabel: boolean;
  @Input()
  linkedCalendars: boolean;
  @Input()
  dateLimit: number = null;
  @Input()
  singleDatePicker: boolean;
  @Input()
  showWeekNumbers: boolean;
  @Input()
  showISOWeekNumbers: boolean;
  @Input()
  showDropdowns: boolean;
  @Input()
  isInvalidDate: Function;
  @Input()
  isCustomDate: Function;
  @Input()
  isTooltipDate: Function;
  @Input()
  showClearButton: boolean = true;
  @Input()
  customRangeDirection: boolean;
  @Input()
  ranges: any;
  @Input()
  opens: string;
  @Input()
  drops: string;
  firstMonthDayClass: string;
  @Input()
  lastMonthDayClass: string;
  @Input()
  emptyWeekRowClass: string;
  @Input()
  firstDayOfNextMonthClass: string;
  @Input()
  lastDayOfPreviousMonthClass: string;
  @Input()
  keepCalendarOpeningWithRange: boolean;
  @Input()
  showRangeLabelOnInput: boolean;
  @Input()
  showCancel: boolean = false;
  @Input()
  lockStartDate: boolean = false;
  // timepicker variables
  @Input()
  timePicker: Boolean = false;
  @Input()
  timePicker24Hour: Boolean = false;
  @Input()
  timePickerIncrement: number = 1;
  @Input()
  timePickerSeconds: Boolean = false;
  @Input() closeOnAutoApply = true;
  _locale: LocaleConfig = {};
  @Input() set locale(value) {
    this._locale = { ...this._localeService.config, ...value };
  }
  @Input() question: any;
  get locale(): any {
    return this._locale;
  }
  @Input()
  private _endKey: string = 'endDate';
  private _startKey: string = 'startDate';
  @Input() set startKey(value) {
    if (value !== null) {
      this._startKey = value;
    } else {
      this._startKey = 'startDate';
    }
  }
  @Input() set endKey(value) {
    if (value !== null) {
      this._endKey = value;
    } else {
      this._endKey = 'endDate';
    }
  }

  @Input()
  outPutFormat: string;

  notForChangesProperty: Array<string> = [
    'locale',
    'endKey',
    'startKey'
  ];

  get value() {
    return this._value || null;
  }
  set value(val) {
    this._value = val;
    this._onChange(val);
    this._changeDetectorRef.markForCheck();
  }

  @Input()
  enableInput: boolean = false;

  @Output('change') onChange: EventEmitter<Object> = new EventEmitter();
  @Output('rangeClicked') rangeClicked: EventEmitter<Object> = new EventEmitter();
  @Output('datesUpdated') datesUpdated: EventEmitter<Object> = new EventEmitter();
  @Output() startDateChanged: EventEmitter<Object> = new EventEmitter();
  @Output() endDateChanged: EventEmitter<Object> = new EventEmitter();
  @Output() choosedDate: EventEmitter<Object> = new EventEmitter();
  constructor(
    public viewContainerRef: ViewContainerRef,
    public _changeDetectorRef: ChangeDetectorRef,
    private _componentFactoryResolver: ComponentFactoryResolver,
    private _el: ElementRef,
    private _renderer: Renderer2,
    private differs: KeyValueDiffers,
    private _localeService: LocaleService,
    private utilsService: UtilService,
    private validateService: ValidationService,
    private ngZone: NgZone
  ) {
    this.drops = 'down';
    this.opens = 'auto';
    const componentFactory = this._componentFactoryResolver.resolveComponentFactory(DaterangepickerComponent);
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent(componentFactory);
    this.picker = (<DaterangepickerComponent>componentRef.instance);
    this.picker.inline = false; // set inline to false for all directive usage
  }
  ngOnInit() {
    this.sub.add(this.picker.startDateChanged.asObservable().subscribe((itemChanged: any) => {
      this.startDateChanged.emit(itemChanged);
    }));
    this.sub.add(this.picker.endDateChanged.asObservable().subscribe((itemChanged: any) => {
      this.endDateChanged.emit(itemChanged);
    }));
    this.sub.add(this.picker.rangeClicked.asObservable().subscribe((range: any) => {
      this.rangeClicked.emit(range);
    }));
    this.sub.add(this.picker.datesUpdated.asObservable().subscribe((range: any) => {
      this.datesUpdated.emit(range);
    }));
    this.sub.add(this.picker.choosedDate.asObservable().subscribe((change: any) => {
      if (change) {
        let value = {};
        if (this.singleDatePicker) {
          if (this.outPutFormat == OutPutFormat.LocalDate)
            value = change.startDate ? moment(change.startDate).format('DD/MM/YYYY') : change.startDate;
          else if (this.outPutFormat == OutPutFormat.LocalDateTime)
            value = change.startDate ? moment(change.startDate).format('DD/MM/YYYY HH:mm:ss') : change.startDate;
          // else if (!this.timePicker) {
          //   if (change.startDate) {
          //     change.startDate.minutes(0);
          //     change.startDate.seconds(0);
          //     change.startDate.millisecond(0);
          //     change.startDate.hour(0);
          //   }
          //   value = change.startDate ? this.utilsService.toUtcDate(change.startDate).valueOf() : change.startDate;
          //   console.log("value of millis is as::", value);

          // }
          else
            value = change.startDate ? this.utilsService.toUtcDate(change.startDate).valueOf() : change.startDate;
        } else {
          if(change && change.chosenRange && change.chosenRange != '' && change.chosenRange != undefined && change.chosenRange != null)
            this.question['chosenRange'] = change.chosenRange;
          if (this.outPutFormat == OutPutFormat.LocalDate) {
            value[this._startKey] = change.startDate ? moment(change.startDate).format('DD/MM/YYYY') : change.startDate;
            value[this._endKey] = change.endDate ? moment(change.endDate).format('DD/MM/YYYY') : change.endDate;
          }
          else if (this.outPutFormat == OutPutFormat.LocalDateTime) {
            value[this._startKey] = change.startDate ? moment(change.startDate).format('DD/MM/YYYY HH:mm:ss') : change.startDate;
            value[this._endKey] = change.endDate ? moment(change.endDate).format('DD/MM/YYYY HH:mm:ss') : change.endDate;
          }
          else {
            value[this._startKey] = change.startDate ? this.utilsService.toUtcDate(moment(change.startDate)).valueOf() : change.startDate;
            value[this._endKey] = change.endDate ? this.utilsService.toUtcDate(moment(change.endDate)).valueOf() : change.endDate;
          }
        }
        this.value = value;
        this.onChange.emit(value);
        if (typeof change.chosenLabel === 'string') {
          this._el.nativeElement.value = change.chosenLabel;
        }

        this.choosedDate.emit(change);
      }
    }));
    this.picker.firstMonthDayClass = this.firstMonthDayClass;
    this.picker.lastMonthDayClass = this.lastMonthDayClass;
    this.picker.emptyWeekRowClass = this.emptyWeekRowClass;
    this.picker.firstDayOfNextMonthClass = this.firstDayOfNextMonthClass;
    this.picker.lastDayOfPreviousMonthClass = this.lastDayOfPreviousMonthClass;
    this.picker.drops = this.drops;
    this.picker.opens = this.opens;
    this.localeDiffer = this.differs.find(this.locale).create();
    this.picker.closeOnAutoApply = this.closeOnAutoApply;
    this.boundOutsideClick = this.outsideClick.bind(this);
    this.ngZone.runOutsideAngular(() => {
      document.addEventListener(
        'click',
        this.boundOutsideClick
      );
    })
  }
  ngOnDestroy(): void {
      this.sub.unsubscribe();
      document.removeEventListener('click', this.boundOutsideClick);
      this.viewContainerRef.clear();
      this.picker = null;
  }
  ngOnChanges(changes: SimpleChanges): void {
    for (const change in changes) {
      if (changes.hasOwnProperty(change)) {
        if (this.notForChangesProperty.indexOf(change) === -1) {
          this.picker[change] = changes[change].currentValue;
        }
      }
    }
  }

  ngDoCheck() {
    if (this.localeDiffer) {
      const changes = this.localeDiffer.diff(this.locale);
      if (changes) {
        this.picker.updateLocale(this.locale);
      }
    }
  }

  onBlur() {
    this._onTouched();
  }

  open(event?: any) {
    this.picker.show(event);
    setTimeout(() => {
      this.setPosition();
    });
  }

  hide(e?) {
    this.picker.hide(e);
  }
  toggle(e?) {
    if (this.picker.isShown) {
      this.hide(e);
    } else {
      this.open(e);
    }
  }

  clear() {
    this.picker.clear();
  }

  writeValue(value) {
    this.setValue(value);
  }
  registerOnChange(fn) {
    this._onChange = fn;
  }
  registerOnTouched(fn) {
    this._onTouched = fn;
  }
  validate(value: FormControl) {
    if (this._validations) {
      return this.validateService.setValidation(value, this._validations);
    }
  }
  private setValue(val: any) {
    if (val) {
      this.value = val;
      if (this.singleDatePicker) {
        this.picker.setStartDate(val);
        this.picker.setEndDate(val);
      } else {
        try {
          //added to handle daterange data fetched from backend in from of string
          if (typeof val === 'string') {
            val = JSON.parse(val);
          }
  
          if (!val || (val[this._startKey] === null && val[this._endKey] === null)) {
            this.picker.clear();
            return;
          }
        } catch (error) {
          console.error("data can not be parsed for given date range", error);
          return; 
        }
        if (val[this._startKey]) {
          this.picker.setStartDate(val[this._startKey]);
        }
        if (val[this._endKey]) {
          this.picker.setEndDate(val[this._endKey]);
        }
      }
      this.picker.calculateChosenLabel();
      if (this.picker.chosenLabel) {
        this._el.nativeElement.value = this.picker.chosenLabel;
      }
    } else {
      this.picker.clear();
    }
  }
  /**
   * Set position of the calendar
   */
  setPosition() {
    let style;
    let containerTop;
    const container = this.picker.pickerContainer.nativeElement;
    const element = this._el.nativeElement;
    if (this.drops && this.drops === 'up') {
      containerTop = (element.offsetTop - container.clientHeight) + 'px';
    } else {
      containerTop = 'auto';
    }
    if (this.opens === 'left') {
      style = {
        top: containerTop,
        left: (element.offsetLeft - container.clientWidth + element.clientWidth) + 'px',
        right: 'auto'
      };
    } else if (this.opens === 'center') {
      style = {
        top: containerTop,
        left: (element.offsetLeft + element.clientWidth / 2
          - container.clientWidth / 2 - 30) + 'px',
        right: 'auto'
      };
    } else if (this.opens === 'right') {
      style = {
        top: containerTop,
        left: element.offsetLeft + 'px',
        right: 'auto'
      };
    } else {
      const position = element.offsetLeft + element.clientWidth / 2 - container.clientWidth / 2;
      if (position < 0) {
        style = {
          top: containerTop,
          left: 'unset',//element.offsetLeft + 'px',
          right: 'auto'
        };
      }
      else {
        style = {
          top: containerTop,
          left: position + 'px',
          right: 'auto'
        };
      }
    }
    if (style) {
      this._renderer.setStyle(container, 'top', style.top);
      this._renderer.setStyle(container, 'left', style.left);
      this._renderer.setStyle(container, 'right', style.right);
    }
  }
  inputChanged(e) {
    if (e.target.tagName.toLowerCase() !== 'input') {
      return;
    }
    if (!e.target.value.length) {
      if (this.value) {
        this.value = "";
      }
      return;
    }

    if (this.singleDatePicker && this.enableInput && e.keyCode != 8 && e.keyCode != 46) {
      if (e.target.value.length == 2) {
        let twodigitpattern = /^\d{1,2}$/;
        if (e.target.value.match(twodigitpattern)) {
          e.target.value += '/';
        }
        else { e.target.value = ""; return; }
      } else if (e.target.value.length == 5) {
        let nextpattern = /^\d{1,2}\/\d{1,2}$/;
        if (e.target.value.match(nextpattern)) {
          e.target.value += '/';
        }
        else { e.target.value = ""; return; }
      } else if (e.target.value.length == 10) {
        let lastpattern = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
        let validate = this.validateDate(e.target.value);
        if (!e.target.value.match(lastpattern) || !validate) {
          e.target.value = "";
          return;
        }
      }else if (e.target.value.length > 10) {
        e.target.value = e.target.value.substring(0, e.target.value.length - 1);
        return;
      }
    }

    const dateString = e.target.value.split(this.picker.locale.separator);
    let start = null, end = null;
    if (dateString.length === 2) {
      start = moment(dateString[0], this.picker.locale.format);
      end = moment(dateString[1], this.picker.locale.format);
    }
    if (this.singleDatePicker || start === null || end === null) {
      start = moment(e.target.value, this.picker.locale.format);
      end = start;
    }
    if (!start.isValid() || !end.isValid()) {
      if (e.target.value.length == 10) {
        e.target.value = "";
      }
      return;
    }

    if (this.singleDatePicker && this.enableInput) {
      if (e.target.value.length == 10) {
        let startDate = moment(e.target.value, 'DD/MM/YYYY');
        let currentDate = moment().endOf('day');
        let lastDate = moment().startOf('year').subtract(120, 'years');
        console.log('last date ---> ', lastDate);
        if (lastDate > startDate) {
          e.target.value = "";
          this.picker.setStartDate(currentDate);
          this.picker.setEndDate(currentDate);
          this.picker.updateView();
        } else if (startDate > currentDate && this.maxDateNumber != undefined) {
          e.target.value = "";
          this.picker.setStartDate(currentDate);
          this.picker.setEndDate(currentDate);
          this.picker.updateView();
        } else {
          this.value = e.target.value;
          this.picker.setStartDate(startDate);
          this.picker.setEndDate(startDate);
          this.picker.updateView();
        }
      }
    } else {
      this.picker.setStartDate(start);
      this.picker.setEndDate(end);
      this.picker.updateView();
    }

  }

  validateDate(date){
    var data = date.split("/");
    // using ISO 8601 Date String
    if (isNaN(Date.parse(data[2] + "-" + data[1] + "-" + data[0]))) {
      return false;
    }
    return true;
  }

  /**
   * For click outside of the calendar's container
   * @param event event object
   */

  outsideClick(event): void {
    if (!event.target) {
      return;
    }

    if (event.target.classList.contains('ngx-daterangepicker-action')) {
      return;
    }

    const clickedInsideInput = this._el.nativeElement.contains(event.target);
    const clickedInsidePicker = this.picker && this.picker.pickerContainer && this.picker.pickerContainer.nativeElement.contains(event.target);
    const key = this.question != undefined && this.question.key != undefined ? this.question.key : false;
    const clickedSameKeyInput = key && event.target.id === key;

    if (clickedInsideInput || clickedInsidePicker || clickedSameKeyInput) {
      return;
    }

    this.hide();
  }
}


enum OutPutFormat {
  LocalDate = "localDate",
  LocalDateTime = "localDateTime"
}
